import { Controller } from "@hotwired/stimulus"
import { showToast } from "../utils/show_toast"

// Turns Rails flash notices/alerts into not-a-toast on full page loads
// (layouts via shared/flash_toasts). On connect, shows those messages and
// removes this element.
//
// For Turbo Stream responses, use the custom "toast" stream action instead.
// For click-to-show without navigation, use simple-toast.
//
// Turbo Drive: connect can run around body swap. Showing immediately can attach
// the toast to a body Turbo then discards. Skip cached previews; defer two
// animation frames so the toast lands on the settled document.
export default class extends Controller {
  static values = {
    notices: { type: Array, default: [] },
    alerts: { type: Array, default: [] },
    duration: Number,
    theme: String
  }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!this.element.isConnected) return
        this.showToasts()
        this.element.remove()
      })
    })
  }

  showToasts() {
    const options = this.hasDurationValue && this.durationValue > 0
      ? { duration: this.durationValue }
      : {}
    const noticeTheme = this.hasThemeValue && this.themeValue !== ""
      ? this.themeValue
      : "success"
    this.noticesValue.forEach(message => showToast(message, noticeTheme, options))
    this.alertsValue.forEach(message => showToast(message, "error", options))
  }
}
